<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Delivery Method" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-delivery-method-form [deliveryMethod]="deliveryMethod" *ngIf="deliveryMethod"></app-delivery-method-form>
        </form>
      </div>
    </section>
  </div>
</div>
